<template>
	<div class="mouse-app-shell">
		<app-header :search="search" :notification="notification" :theme="theme" :file="currentComponentName"></app-header>
		<top-navigation :no-collapsing="true"></top-navigation>
		<stacker-path v-if="stacker.length > 1" :pages="stacker"></stacker-path>
		<div class="layout">
			<side-bar v-if="sideMenu" :menu="sideMenu" :history="showHistory"></side-bar>
			<div class="content is-container" id="layout-content"><router-view></router-view></div>
		</div>
		<chat-component></chat-component>
		<scroll-up-component></scroll-up-component>
	</div>
</template>

<script setup lang="ts">
import AppHeader from "@/ui/mouse/AppHeader.vue";
import TopNavigation from "@/ui/mouse/TopNavigation.vue";
import {onMounted, computed} from "vue";
import SideBar from "@/ui/mouse/SideBar.vue";
import type {ShellProps} from "@/ui/ShellProps";
import StackerPath from "@/ui/mouse/StackerPath.vue";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import ChatComponent from "@/ui/mouse/ChatComponent.vue";
import ScrollUpComponent from "@/ui/mouse/ScrollUpComponent.vue";

const props = defineProps<ShellProps>();

const navStore = useNavigationStore();
const {sideMenu, showHistory, stacker} = storeToRefs(navStore);

const route = useRoute()

const currentComponentName = computed<string>(() => {
	const matched = route.matched.at(-1);
	const strutsName = (matched?.meta?.struts) as string;
	return strutsName ?? props.file;
});

onMounted(() => {
	navStore.reloadHistory();
});
</script>

<style>
.mouse-app-shell {
	min-height: 100vh;
	min-height: 100svh;

	display: flex;
	flex-direction: column;

	& > div.layout {
		flex-grow: 1;
	}
}
</style>
